import PipeCard from "../../../pipe-common/PipeCard";
import Terranova75XAPumpReadBack from "./common/Terranova75XAPumpReadBack";
import React from "react";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";

export default function Terranova752AReadBack({pipe, data}) {
    const indicators = data && data["pumps"] ? {
        "pump_first": data["pumps"]["1"],
        "pump_second": data["pumps"]["2"]
    } : {};

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12} container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                        <Grid item xs={12}>
                            <Typography align={"center"}>Ion Pump 1</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Terranova75XAPumpReadBack data={indicators["pump_first"]}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                        <Grid item xs={12}>
                            <Typography align={"center"}>Ion Pump 2</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Terranova75XAPumpReadBack data={indicators["pump_second"]}/>
                        </Grid>
                    </Grid>
                </Grid>
            }
        />
    );
}